import { h } from 'preact';
import * as actions from 'store/actions';

let staticRender;
staticRender = (props) => (
	<div>
		<div>
			<script data-obct type="text/javascript" />
			<script dangerouslySetInnerHTML={{ __html: `
				!function(_window, _document) {
					var OB_ADV_ID='00d05b26525a7dd7d0c13df1a712b086ca';
					if (_window.obApi) {
						var toArray = function(object) {
							return Object.prototype.toString.call(object) === '[object Array]' ? object : [object];
						};
						_window.obApi.marketerId = toArray(_window.obApi.marketerId).concat(toArray(OB_ADV_ID))
						return;
					}
					var api = _window.obApi = function() {
						api.dispatch ? api.dispatch.apply(api, arguments) : api.queue.push(arguments);
					}

					api.version = '1.1';
					api.loaded = true;api.marketerId = OB_ADV_ID;
					api.queue = [];
					var tag = _document.createElement('script');
					tag.async = true;
					tag.src = '//amplify.outbrain.com/cp/obtp.js';
					tag.type = 'text/javascript';
					var script = _document.getElementsByTagName('script')[0];
					script.parentNode.insertBefore(tag, script);
				}

				(window, document);
				obApi('track', 'PAGE_VIEW');
				`}} />
		</div>
		<div>
			<script dangerouslySetInnerHTML={{ __html: `
				!function(e){if(!window.pintrk){window.pintrk = function () {
				window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
				n=window.pintrk;n.queue=[],n.version="3.0";var
				t=document.createElement("script");t.async=!0,t.src=e;var
				r=document.getElementsByTagName("script")[0];
				r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
				pintrk('load', '2613751407518');
				pintrk('page');
				`}} />
			<noscript>
			<img height="1" width="1" style="display:none;" alt="" src="https://ct.pinterest.com/v3/?event=init&tid=2613751407518&pd[em]=<hashed_email_address>&noscript=1" />
			</noscript>
		</div>
	</div>
);


let storeListeners = {};

storeListeners[actions.SET_ACTIVE_PAGE] = (activePage) => {
	if (typeof window.twq === 'function') {
		twq('track','PageView');
	}
	if (typeof window.snaptr === 'function') {
		snaptr('track', 'PAGE_VIEW');
	}
	if (typeof window.obApi === 'function') {
		obApi('track', 'PAGE_VIEW');
	}
	if (typeof window.pintrk === 'function') {
		pintrk('page');
	}

};

storeListeners[actions.TICKET_LINK_CLICKED] = () => {
	if (typeof window.twq === 'function') {
		twq('track','PageView');
	}
	if (typeof window.snaptr === 'function') {
		snaptr('track', 'PAGE_VIEW');
	}
	if (typeof window.obApi === 'function') {
		obApi('track', 'PAGE_VIEW');
	}
	if (typeof window.pintrk === 'function') {
		pintrk('page');
	}
};

export const disabledLevels = {
	// base: true,
	// studio: true,
	// studioRegion: true,
	// title: true,
};

export {
	staticRender,
	storeListeners
};
